import { type MutationHookOptions, useMutation } from "@apollo/client";
import { ReplySupportRequestMutation } from "../graphql/mutations";
import type {
  ReplySupportRequestMutationType,
  ReplySupportRequestMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useReplySupportRequestMutation = (
  options?: MutationHookOptions<
    ReplySupportRequestMutationType,
    ReplySupportRequestMutationVariablesType
  >
) =>
  useMutation<
    ReplySupportRequestMutationType,
    ReplySupportRequestMutationVariablesType
  >(ReplySupportRequestMutation, options);
